async function createFile(fileUrl, fileName) {
  const url = process.env.VUE_APP_MEDIA_URL + fileUrl;
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type: 'application/pdf',
  };
  return new File([data], fileName, metadata);
}

export default async function convertPdfUrlToBlob(fileUrl: string, fileName: string) {
  const res = await createFile(fileUrl, fileName);
  return window.URL.createObjectURL(res);
}
